import { gql } from '@apollo/client'

export const messageManagemenPageDfmFeedbackMessages = gql`
    query messageManagemenPageDfmFeedbackMessages(
        $platformProcessId: String
        $type: DfmFeedbackMessageType
        $topicId: UUID
        $disabled: Boolean
    ) {
        dfmFeedbackMessages(
            platformProcessId: $platformProcessId
            type: $type
            topicId: $topicId
            disabled: $disabled
        ) {
            id
            code
            type
            disabled
            severity
            message
            platformProcessId
            link
            title
            dfmTopic {
                id
                label
            }
            createdAt
            createdBy {
                id
            }
            updatedAt
            updatedBy {
                id
                displayName
            }
            deletedAt
            deletedBy {
                id
            }
        }
    }
`

export const createDfmFeedbackMessageMutation = gql`
    mutation createDfmFeedbackMessage(
        $code: String!
        $type: DfmFeedbackMessageType!
        $severity: DfmFeedbackSeverity!
        $platformProcessId: String!
        $title: String!
        $message: String!
        $link: String
        $topicId: UUID
        $disabled: Boolean!
    ) {
        createDfmFeedbackMessage(
            messageAttrs: {
                code: $code
                type: $type
                severity: $severity
                title: $title
                message: $message
                link: $link
                platformProcessId: $platformProcessId
                topicId: $topicId
                disabled: $disabled
            }
        ) {
            id
        }
    }
`

export const editDfmFeedbackMessageMutation = gql`
    mutation editDfmFeedbackMessage(
        $id: UUID!
        $severity: DfmFeedbackSeverity!
        $title: String!
        $message: String!
        $platformProcessId: String!
        $link: String
        $disabled: Boolean!
    ) {
        editDfmFeedbackMessage(
            messageAttrs: {
                id: $id
                severity: $severity
                title: $title
                message: $message
                platformProcessId: $platformProcessId
                link: $link
                disabled: $disabled
            }
        ) {
            id
        }
    }
`
